var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"mouse-cursor"},[_c('nav-bar'),(_vm.isAuthenticated)?_c('left-nav-bar'):_vm._e(),_c('v-main',{staticClass:"bg"},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }